import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableVirtuoso } from 'react-virtuoso';



const columns = [
  {
    width: 200,
    label: 'Ref',
    dataKey: 'tx_ref'
  },  
  {
    width: 200,
    label: 'ID',
    dataKey: 'transaction_id'
  },
  {
    width: 100,
    label: 'Currency',
    dataKey: 'currency',
  },  
  {
    width: 120,
    label: 'Status',
    dataKey: 'status',
  },
  {
    width: 100,
    label: 'Completed',
    dataKey: 'completed'
  },
  {
    width: 150,
    label: 'Amount Settled',
    dataKey: 'amount_settled'
  },
  {
    width: 100,
    label: 'App Fee',
    dataKey: 'app_fee'
  },
  {
    width: 100,
    label: 'Payment Type',
    dataKey: 'payment_type'
  },
  {
    width: 100,
    label: 'Duration',
    dataKey: 'duration'
  },
  {
    width: 150,
    label: 'Product',
    dataKey: 'product',
  },
  {
    width: 200,
    label: 'Coupon Code',
    dataKey: 'couponCode'
  },
  {
    width: 220,
    label: 'Customer Email',
    dataKey: 'customer.email'
  },
  {
    width: 180,
    label: 'Customer Name',
    dataKey: 'customer.fullName'
  },
  {
    width: 150,
    label: 'IP',
    dataKey: 'ip'
  },
  {
    width: 150,
    label: 'Time',
    dataKey: 'createdAt',
  }
];


const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
  ),
  TableHead,
  TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

function fixedHeaderContent(sortBy, sortDir, onSortChange) {
  const arrow = (key) => {
    if (sortBy !== key) return '';
    return sortDir === 'asc' ? ' ▲' : ' ▼';
  };
  return (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align={column.numeric || false ? 'right' : 'left'}
          style={{ width: column.width, cursor: 'pointer' }}
          sx={{
            backgroundColor: '#c0d1d457',
            fontWeight: 600
          }}
          onClick={() => onSortChange && onSortChange(column.dataKey)}
        >
          {column.label}{arrow(column.dataKey)}
        </TableCell>
      ))}
    </TableRow>
  );
}

const getValue = (row, dataKey) => {
  const value = dataKey.split('.').reduce((acc, k) => (acc == null ? undefined : acc[k]), row);
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return value;
};

function rowContent(_index, row) {
  return (
    <React.Fragment>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          align={column.numeric || false ? 'right' : 'left'}
        >
            {getValue(row, column.dataKey)}
        </TableCell>
      ))}
    </React.Fragment>
  );
}

export default function TransactionsTable(props) {
  const { sortBy, sortDir, onSortChange } = props;
  return (
    <Paper style={{ height: "80vh", width: '100%' }}>
      <TableVirtuoso
        data={props.allTransactions}
        components={VirtuosoTableComponents}
        fixedHeaderContent={() => fixedHeaderContent(sortBy, sortDir, onSortChange)}
        itemContent={rowContent}
      />
    </Paper>
  );
}
